import React from 'react';
import { Button } from 'rebass/styled-components';
import { faPencil, faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import { Box } from 'shared/components/display';

import { BUTTON_VARIANTS } from 'shared/styles/button';

import styles from './styles';

interface Props {
  onClick: () => void;
  className?: string;
  editing?: boolean;
  variant?: string;
  display?: 'vertical' | 'horizontal';
  hideLabel?: boolean;
}
const EditButton: React.FC<Props> = ({
  className,
  onClick,
  editing,
  variant = BUTTON_VARIANTS.TEXT_ONLY,
  display = 'vertical',
  hideLabel = false,
}) => {
  return (
    <Box as="span" css={styles} className={cs('edit-button', className, `edit-button--${display}`)}>
      <Button variant={variant} onClick={onClick} className="edit-button__btn">
        <FontAwesomeIcon icon={editing ? faX : faPencil} className="edit-button__btn-icon" />
        {!hideLabel && (editing ? 'Cancel' : 'Edit')}
      </Button>
    </Box>
  );
};

export default EditButton;
